import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import {
  createUploadFormMockSchema,
  createUploadFormMockUiSchema,
} from '../../mocks/uploadForm';
import { UISchemaElement } from '@jsonforms/core';
import { JsonSchema } from '@jsonforms/core/src/models/jsonSchema';

export const createUploadFormMock = () => {
  const schema: JsonSchema = createUploadFormMockSchema();
  const uiSchema: UISchemaElement = createUploadFormMockUiSchema();

  return {
    id: '0',
    schema,
    uiSchema,
  };
};

export const fetchUploadFormMock = () => {
  const data = createUploadFormMock();

  axiosMock.onGet(API_URL.uploadForm).reply(200, data);
};
